import connectAsync from '../../utils/connectAsync';
import { selectIsAuthenticated } from '../../selectors/auth';
import { getMetricsAuthorization } from '../../actions/metrics';
import MetricsRoute from './MetricsRoute';

function fetchMetricsAuthState({ store }) {
  const state = store.getState();
  if (selectIsAuthenticated(state)) {
    return getMetricsAuthorization();
  }
  return null;
}

export default connectAsync([fetchMetricsAuthState])(MetricsRoute);
